<template>
  <fn-section
    constrained="l"
    padding-top="xs"
    padding-bottom="xs"
  >
    <fn-grid>
      <fn-grid-item columns="12">
        <div class="seo-links">
          <h2>{{ $t('productListing.relatedLinksHeadline') }}</h2>
          <fn-list
            class="seo-links-container"
            unstyled
            horizontal
          >
            <li
              v-for="link in relatedLinks"
              :key="link.brandLink ? link.url : link.baseUrl"
              class="seo-link-item"
            >
              <fn-link
                v-if="link?.brandLink"
                :to="link.url"
              >
                {{ link.name }}
              </fn-link>
              <fn-link
                v-else
                :to="getRelatedLink(link)"
              >
                <span v-html="link.headlineOverride" />
              </fn-link>
            </li>
          </fn-list>
        </div>
      </fn-grid-item>
    </fn-grid>
  </fn-section>
</template>

<script>
export default {
  props: {
    relatedLinks: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getRelatedLink(link) {
      if (!link.query) {
        return link.fullUrl;
      }

      return `${link.baseUrl}${link.query}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.seo-links-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: $pad;
  grid-row-gap: $pad;
  background-color: palette(sand, base);
  padding: $pad math.div($pad, 2);

  :deep(.link) {
    color: palette(black);
  }
}
</style>
